import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  AccountLogPasswordResetMutation,
  AccountLogPasswordResetMutationVariables,
} from '@gql/graphql';

export const ACCOUNT_LOG_PASSWORD_RESET = graphql(`
  mutation AccountLogPasswordReset($actionCode: String, $message: String) {
    logPasswordReset(actionCode: $actionCode, message: $message)
  }
`);

export const useLogPasswordReset = () => {
  const [logPasswordReset, { loading, error }] = useMutation<
    AccountLogPasswordResetMutation,
    AccountLogPasswordResetMutationVariables
  >(ACCOUNT_LOG_PASSWORD_RESET);

  return {
    logPasswordReset,
    logPasswordResetLoading: loading,
    logPasswordResetError: error,
  };
};
